import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { DELIVERY_NOTIFICATIONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createDeliveryNotificationAction = createAsyncThunk(
    'communication/createDeliveryNotificationAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(DELIVERY_NOTIFICATIONS_PATH, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createDeliveryNotificationSlice = createSlice({
    name: 'createDeliveryNotificationSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createDeliveryNotificationAction.pending, () => STATE__API__STARTED);
        builder.addCase(createDeliveryNotificationAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createDeliveryNotificationAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createDeliveryNotificationState = (state) => state.communication.createDeliveryNotification;
export default createDeliveryNotificationSlice.reducer;
